import { convertDateToUTC } from '../convertDateToUTC';

export const getDirectusDateTimestamp = (dateString: string) => +convertDateToUTC(`${dateString}Z`);
